<div class="popover-root" [ngClass]="cssClass">
  @if (showBackdrop) {
    <div
      class="popover-backdrop"
      [class.visible]="isVisible"
      (click)="onBackdropClick()">
    </div>
  }

  <div
    #popoverContainer
    class="popover-container"
    [class.visible]="isVisible"
    [ngClass]="cssClass"
    [ngStyle]="{ top: popoverY + 'px', left: popoverX + 'px' }">
    <ng-template #popoverContent></ng-template>
  </div>
</div>
